import { render, staticRenderFns } from "./NovoAnexo.vue?vue&type=template&id=38172d73&scoped=true"
import script from "./NovoAnexo.vue?vue&type=script&lang=js"
export * from "./NovoAnexo.vue?vue&type=script&lang=js"
import style0 from "./NovoAnexo.vue?vue&type=style&index=0&id=38172d73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38172d73",
  null
  
)

export default component.exports